/* ArchHome — Theme JS
   ─────────────────── */

'use strict';

// ── Mobile menu ──────────────────────────────
const mobileMenu = {
  menu: null,
  toggle: null,
  close: null,

  init() {
    this.menu   = document.getElementById('mobile-menu');
    this.toggle = document.getElementById('nav-toggle');
    this.close  = document.getElementById('mobile-menu-close');
    if (!this.menu) return;
    this.toggle?.addEventListener('click', () => this.open());
    this.close?.addEventListener('click', () => this.closeMenu());
    document.addEventListener('keydown', e => { if (e.key === 'Escape') this.closeMenu(); });
  },

  open() {
    this.menu.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    this.close?.focus();
  },

  closeMenu() {
    this.menu.classList.remove('is-open');
    document.body.style.overflow = '';
    this.toggle?.focus();
  }
};

// ── Cart ─────────────────────────────────────
const cart = {
  async getCart() {
    const res = await fetch('/cart.js');
    return res.json();
  },

  async addItem(variantId, quantity = 1) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity })
    });
    if (!res.ok) throw new Error('Could not add to cart');
    return res.json();
  },

  async updateItem(variantId, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity })
    });
    return res.json();
  },

  updateCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  },

  async refreshCount() {
    try {
      const data = await this.getCart();
      this.updateCount(data.item_count);
    } catch (e) {
      console.error('Cart refresh failed', e);
    }
  }
};

// ── Add to cart button ────────────────────────
function initAddToCart() {
  const form = document.getElementById('product-form');
  if (!form) return;

  form.addEventListener('submit', async e => {
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const variantId = form.querySelector('[name="id"]')?.value;
    if (!variantId) return;

    const originalText = btn.textContent;
    btn.textContent = 'Adding…';
    btn.disabled = true;

    try {
      await cart.addItem(variantId);
      btn.textContent = 'Added';
      setTimeout(() => {
        btn.textContent = originalText;
        btn.disabled = false;
      }, 1800);
      await cart.refreshCount();
    } catch (err) {
      btn.textContent = 'Try again';
      btn.disabled = false;
      setTimeout(() => { btn.textContent = originalText; }, 2000);
    }
  });
}

// ── Cart page qty controls ────────────────────
function initCartQty() {
  document.querySelectorAll('[data-qty-input]').forEach(input => {
    const minus = input.previousElementSibling;
    const plus  = input.nextElementSibling;
    const variantId = input.dataset.variantId;

    minus?.addEventListener('click', () => {
      const qty = Math.max(0, parseInt(input.value) - 1);
      input.value = qty;
      updateCartItem(variantId, qty);
    });
    plus?.addEventListener('click', () => {
      const qty = parseInt(input.value) + 1;
      input.value = qty;
      updateCartItem(variantId, qty);
    });
    input.addEventListener('change', () => {
      const qty = Math.max(0, parseInt(input.value) || 0);
      input.value = qty;
      updateCartItem(variantId, qty);
    });
  });
}

async function updateCartItem(variantId, quantity) {
  try {
    await cart.updateItem(variantId, quantity);
    if (quantity === 0) window.location.reload();
    await cart.refreshCount();
  } catch (e) {
    console.error('Cart update failed', e);
  }
}

// ── Product gallery ───────────────────────────
function initGallery() {
  const thumbs = document.querySelectorAll('[data-gallery-thumb]');
  const main   = document.getElementById('gallery-main');
  if (!thumbs.length || !main) return;

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      const src = thumb.dataset.galleryThumb;
      const alt = thumb.alt || '';
      main.src = src;
      main.alt = alt;
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
    });
  });
}

// ── Scroll-based header style ─────────────────
function initHeaderScroll() {
  const header = document.querySelector('.site-header');
  if (!header) return;
  const onScroll = () => {
    header.classList.toggle('scrolled', window.scrollY > 20);
  };
  window.addEventListener('scroll', onScroll, { passive: true });
}

// ── Intersection observer fade-ins ────────────
function initFadeIns() {
  const els = document.querySelectorAll('.product-card, .section-header');
  if (!('IntersectionObserver' in window)) return;
  const obs = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('fade-up');
        obs.unobserve(e.target);
      }
    });
  }, { threshold: 0.1 });
  els.forEach(el => obs.observe(el));
}

// ── Boot ──────────────────────────────────────
document.addEventListener('DOMContentLoaded', () => {
  mobileMenu.init();
  initAddToCart();
  initCartQty();
  initGallery();
  initHeaderScroll();
  initFadeIns();
  cart.refreshCount();
});
